export default __webpack_public_path__ + "static/media/castle_card_bg3.615ae8bd.png";